export default {
  computed: {
    isCompareMode() {
      return this.$route.query.compare_node_id != undefined && this.$route.query.compare_node_glk != undefined
    }
  }
}